import { fromEvent } from 'rxjs';
import { FormControl, Validators } from '@angular/forms';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

/**
 * enums
 */
import { URL_TYPE } from 'src/app/core/enums/http-request/resources-url/resources-url-types';

/**
 * interfaces
 */
import { IAdvertisementResponse } from 'src/app/core/interfaces/ads/advertisement';

@Component({
  selector: 'app-advertisement-contract',
  templateUrl: './advertisement-contract.component.html',
  styleUrls: ['./advertisement-contract.component.scss']
})
export class AdvertisementContractComponent implements AfterViewInit {
  
  /************  Inputs  ************/
  /**
   * data
   * @description Advertisement Data
   */
  @ViewChild('IFrame', { read: ElementRef<HTMLIFrameElement> }) public IFrame: ElementRef<HTMLIFrameElement> = null;  

  /************  OutPuts  ************/
  /**
   * DepositEventHandler
   * @description to emit click trigger for pay
   */
  @Output('acceptContract') public AcceptContractEventHandler: EventEmitter<boolean> = new EventEmitter<boolean>();  
  
  /************  Inputs  ************/
  /**
   * data
   * @description Advertisement Data
   */
  @Input({ alias: 'data', required: true }) public AdvertisementData: IAdvertisementResponse = null;


  /************  Fields  ************/
  /**
   * AcceptContract
   */
  public AcceptContractControl: FormControl = new FormControl(false, Validators.requiredTrue)

  /**
   * isLoadingContractFile
   */
  public IsLoadingContractFile: boolean = true;


  /************  Accessors  ************/  
  /**
   * ContractLink
   */
  public get ContractLink(): string | null {
    
    // ES6 Destruction
    const { contract } = this.AdvertisementData

    return contract ? contract : null

  }

  /**
   * 
   */
  public get URL_TYPE(): typeof URL_TYPE {
    return URL_TYPE
  }

  /**
   *
   */
  constructor() {}
  

  /**
   * 
   */
  ngAfterViewInit(): void {

    /**
     * 
     */
    fromEvent(this.IFrame.nativeElement, 'load')
    .subscribe(_ => this.IsLoadingContractFile = false)

  }


  /************  Methods  ************/  
  /**
   * AcceptContract
   * @description to fire AcceptContractEventHandler
   */
  public AcceptContract(): void {
    this.AcceptContractEventHandler.emit(this.AcceptContractControl.value)
  }

}
